import React, { Component } from 'react';
import T from 'prop-types';
// redux
import { connect } from 'react-redux';
import { openModal, closeModal } from '../../redux/reducers/modal';
import { updateUser } from '../../redux/reducers/auth';
// components
import UserProfileSupport from './UserProfileSupport';
import UserProfileClient from './UserProfileClient';
import PageWrapper from '../../components/PageWrapper/PageWrapper';
// styles
import styles from './UserProfile.mod.css';

class UserProfile extends Component {
  deleteAccount = () => {
    const { openModal } = this.props;
    openModal('DELETE_ACCOUNT');
  };

  changePassword = () => {
    const { openModal } = this.props;
    openModal('CHANGE_PASSWORD');
  };

  deleteUserSupport = () => {
    const { openModal } = this.props;
    openModal('DELETE_USER_SUPPORT');
  };

  render() {
    const { user } = this.props;
    const { role, username, email } = user;
    const isSupport = role === 'support';
    const props = {
      changePassword: this.changePassword,
      deleteAccount: this.deleteAccount,
      deleteUserSupport: this.deleteUserSupport,
      ...this.props
    };

    return (
      <PageWrapper className={styles.container}>
        <h2 className="text-center">Hello, {username || email}!</h2>
        {isSupport ? (
          <UserProfileSupport {...props} />
        ) : (
          <UserProfileClient {...props} />
        )}
      </PageWrapper>
    );
  }
}

UserProfile.propTypes = {
  user: T.shape({
    email: T.string.isRequired,
    gender: T.string,
    profile_color: T.string,
    username: T.string,
    birthdate: T.string,
    role: T.string.isRequired
  }),
  openModal: T.func.isRequired,
  closeModal: T.func.isRequired,
  updateUser: T.func.isRequired
};

export default connect(
  state => ({
    user: state.auth.user
  }),
  {
    openModal,
    closeModal,
    updateUser
  }
)(UserProfile);



// WEBPACK FOOTER //
// ./src/containers/UserProfile/UserProfile.jsx